<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      class="elevation-0"
      :key="key"
      hide-default-footer
    >
      <template v-slot:[`item.avatar`]="{ item }">
        <v-img
          v-if="item.avatar != null"
          :src="item.avatar"
          width="50px"
          height="50px"
          style="border-radius: 50%"
        />
        <v-img
          v-else
          src="https://www.hrinasia.com/wp-content/uploads/2016/01/project-management-6.jpg"
          width="50px"
          height="50px"
          style="border-radius: 50%"
        />
      </template>
      <template v-slot:[`item.id_role`]="{ item }">
        <v-btn
          v-if="permission.updateEmployees"
          icon
          :to="'/app/employees/update/' + item.id"
        >
          <v-icon class="mr-2"> mdi-pencil </v-icon></v-btn
        >
        <v-btn v-if="permission.updateEmployees" icon @click="editRole(item)">
          <v-icon>mdi-delete</v-icon></v-btn
        >
      </template>
      <template v-slot:[`item.at_work`]="{ item }">
        <v-chip :color="getColor(item)" dark>
          {{ at_work(item) }}
        </v-chip>
      </template>
      <template v-slot:[`item.position`]="{ item }">
        <v-icon color="primary" v-if="item.position == 'Truck'"
          >mdi-truck</v-icon
        >
        <v-icon v-if="item.position == 'Car'">mdi-car</v-icon>
        <v-icon color="blue" v-if="item.position == 'admin'">mdi-laptop</v-icon>
        <v-icon color="green" v-if="item.position == 'Manager'">
          mdi-card-account-details-outline</v-icon
        >

        {{ item.position }}
      </template>
      <template v-slot:[`item.src`]="{ item }">
        {{ getSRC(item) }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ $subStringDate(item.created_at) }}
      </template>
    </v-data-table>
    <deleteUser
      :dialog="dialog"
      :data="setting"
      @close-dialog="close"
      @deleteEmployee="deleteEmployee"
    />
  </div>
</template>

<script>
import deleteUser from "./deleteUser";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "TableEmployees",
  components: { deleteUser },
  props: ["data"],
  data() {
    return {
      headers: [
        { text: "#ID", value: "id", sortable: true },
        {
          text: this.$t("employees.table.image"),
          value: "avatar",
          sortable: false,
        },
        { text: this.$t("employees.table.name"), value: "name" },
        {
          text: this.$t("employees.table.phone"),
          sortable: false,
          value: "number",
        },
        {
          text: this.$t("employees.table.address"),
          value: "address",
          sortable: false,
        },
        {
          text: this.$t("employees.table.position"),
          value: "position",
          sortable: false,
        },
        { text: this.$t("resorce.title"), value: "src", sortable: true },
        // { text: this.$t("employees.table.created_at"), value: "created_at", sortable: false },
        {
          text: this.$t("employees.table.state"),
          value: "at_work",
          sortable: false,
        },
        {
          text: this.$t("employees.table.edite"),
          value: "id_role",
          align: "left",
        },
      ],
      setting: {},
      dialog: false,
      key: 1,
    };
  },
  computed: {
    ...mapState("users", ["permission"]),
    ...mapState(["geoPlace"]),
    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },
  methods: {
    getSRC(item) {
      try {
        return this.geoPlace.find((element) => element.id == item.src).name;
      } catch {
        return "-";
      }
    },
    close(val) {
      this.dialog = false;
    },
    getColor(data) {
      if (data.at_work == 0) return "red";
      else return "green";
    },
    fromTime(data) {
      moment.locale("ar_SA");
      return moment(data).fromNow();
    },
    at_work(data) {
      if (data.at_work == 0) return this.$t("analys.tableEmployee.disactive");
      else return this.$t("analys.tableEmployee.active");
    },
    editRole(item) {
      this.dialog = false;
      this.dialog = true;
      this.setting = item;
    },
    // employeesNewRoles(val) {
    //   this.employees[this.employees.indexOf(this.data)].role.name = val;
    // },
    deleteEmployee() {
      this.employees.splice(this.data, 1);
    },
  },
};
</script>
